import type {PropsWithChildren, FC, ReactNode} from 'react'
import {useFormContext} from 'react-hook-form'
import {clsx} from 'clsx'
import {ErrorMessage} from '../form'

interface ChoiceGroupProps {
	label: ReactNode
	name: string
	className?: string
	isOptional?: boolean
	requiredErrorMsg?: string
	groupClassName?: string
	labelClassName?: string
}

export const ChoiceGroup: FC<PropsWithChildren<ChoiceGroupProps>> = ({
	className = '',
	groupClassName = '',
	labelClassName = '',
	children,
	name,
	label,
	isOptional = false,
	requiredErrorMsg = '',
}) => {
	const {register, formState} = useFormContext()
	if (!children) return null
	const requiredMsg = requiredErrorMsg || `${String(label)} is required`
	return (
		<fieldset
			className={clsx('mb-4', groupClassName)}
			id={name}
			{...register(name)}
		>
			<h5
				className={clsx(
					'align-middle text-xs font-normal text-pet-primary',
					labelClassName
				)}
			>
				{isOptional ? (
					label
				) : (
					<>
						{label}
						<span className="text-red-600">*</span>
					</>
				)}
			</h5>
			<div className="relative">
				<div className={clsx('md:flex md:flex-wrap', className)}>
					{children}
				</div>
				{formState.errors[name] ? (
					<ErrorMessage message={requiredMsg} />
				) : null}
			</div>
		</fieldset>
	)
}
